export interface Notification {
  id: string;
  userId: string;
  type: NotificationType;
  title: string;
  message: string;
  data?: any; // Additional data specific to notification type
  read: boolean;
  createdAt: string;
  updatedAt: string;
  actionUrl?: string; // URL to navigate to when clicked
  actionText?: string; // Text for action button
}

export enum NotificationType {
  // Task & Calendar
  TaskAssigned = 'task_assigned',
  TaskUpdated = 'task_updated',
  TaskCompleted = 'task_completed',
  TaskDue = 'task_due',
  EventInvite = 'event_invite',
  EventUpdated = 'event_updated',
  
  // Templates
  TemplateReview = 'template_review',
  TemplateCorrections = 'template_corrections',
  TemplateApproved = 'template_approved',
  TemplateRejected = 'template_rejected',
  
  // Photo Log
  PhotosUploaded = 'photos_uploaded',
  PhotosProcessed = 'photos_processed',
  
  // FIN Chat
  FinChatMessage = 'fin_chat_message',
  FinChatMention = 'fin_chat_mention',
  
  // Video Chat
  VideoChatInvite = 'video_chat_invite',
  
  // Jewelry Requests
  JewelryRequestSubmitted = 'jewelry_request_submitted',
  
  // Content Creation
  ContentSubmitted = 'content_submitted',
  ContentApproved = 'content_approved',
  ContentDenied = 'content_denied',
  ContentReworkRequested = 'content_rework_requested',
  
  // Group Calendar
  GroupCalendarEvent = 'group_calendar_event',

  // CCO Sales
  CCOSaleAdded = 'cco_sale_added',

  // Repairs
  RepairQuoteReady = 'repair_quote_ready',

  // Case Map
  CaseMapMove = 'case_map_move',

  // System
  SystemUpdate = 'system_update',
  SystemMaintenance = 'system_maintenance',
  
  // Inventory
  InventoryReport = 'inventory_report',
  
  // General
  General = 'general'
}

export interface NotificationData {
  // Task/Event specific
  taskId?: string;
  eventId?: string;
  assignedBy?: string;
  dueDate?: string;
  
  // Template specific
  templateId?: string;
  reviewerId?: string;
  correctionNotes?: string;
  
  // Photo log specific
  photoCount?: number;
  uploadDate?: string;
  
  // Chat specific
  chatId?: string;
  senderId?: string;
  messagePreview?: string;
  messageId?: string;
  
  // Video chat specific
  sessionId?: string;
  workspaceId?: string;
  invitedBy?: string;
  invitedByName?: string;
  sessionType?: string;
  
  // Jewelry request specific
  requestId?: string;
  requesterName?: string;
  requesterEmail?: string;
  requestType?: string;
  skuCount?: number;
  needByDate?: string;
  store?: string;
  
  // Repair specific
  repairId?: string;
  repairNumber?: string;
  customerName?: string;
  jewelerName?: string;
  quote?: number;
  needsApproval?: boolean;

  // Content creation specific
  contentId?: string;
  contentTitle?: string;
  submittedBy?: string;
  submittedByName?: string;
  platforms?: string[];
  reviewedBy?: string;
  reviewedByName?: string;
  feedback?: string;
}

export interface NotificationPreferences {
  userId: string;
  emailNotifications: boolean;
  pushNotifications: boolean;
  desktopNotifications: boolean;
  taskAssignments: boolean;
  templateReviews: boolean;
  finChatMessages: boolean;
  photoLogUpdates: boolean;
  systemUpdates: boolean;
  updatedAt: string;
} 